import { render, staticRenderFns } from "./ChargeAccountPublic.vue?vue&type=template&id=3a24c940&scoped=true"
import script from "./ChargeAccountPublic.vue?vue&type=script&lang=ts"
export * from "./ChargeAccountPublic.vue?vue&type=script&lang=ts"
import style0 from "./ChargeAccountPublic.vue?vue&type=style&index=0&id=3a24c940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24c940",
  null
  
)

export default component.exports